import { defineStore } from 'pinia'
import { ref } from 'vue'

import api from '@/client/core/api'
import { TCampaign, TGetCampaignParams, TUnauthenticatedAccount } from '@/typings/api/campaigns.type'

import { useSystemStore } from './useSystemStore'

export const useCampaignStore = defineStore('campaignStore', () => {
  const systemStore = useSystemStore()

  const loading = ref(false)
  const firstLoaded = ref(false)
  const error = ref(false)
  const total = ref(0)
  const campaigns = ref<TCampaign[]>([])
  const unauthenticatedAccounts = ref<TUnauthenticatedAccount[]>([])
  const lastQueryParams = ref<any>(null)

  const reset = () => {
    const savedParams = lastQueryParams.value
    loading.value = false
    firstLoaded.value = false
    error.value = false
    total.value = 0
    campaigns.value = []
    unauthenticatedAccounts.value = []
    lastQueryParams.value = savedParams
  }

  const setLastQueryParams = (queryParams: any) => {
    lastQueryParams.value = queryParams
  }

  const fetchCampaignsWithParams = async (params: TGetCampaignParams) => {
    loading.value = true
    error.value = false
    await systemStore.setLoading(true)

    const result = await api.get('/campaigns', { params })

    await systemStore.setLoading(false)
    loading.value = false
    firstLoaded.value = true

    if (!result.data) {
      error.value = true
      return
    }

    campaigns.value = result.data.campaigns
    total.value = result.data.dataCount
    unauthenticatedAccounts.value = result.data.unauthenticatedAccounts

    void systemStore.getCurrentGroup()
  }

  return {
    loading,
    firstLoaded,
    error,
    total,
    campaigns,
    unauthenticatedAccounts,
    lastQueryParams,
    reset,
    setLastQueryParams,
    fetchCampaignsWithParams
  }
})
